





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AuditCriteriaList from '@/views/Project/components/AuditCriteriaList.vue';
import { Action, State } from 'vuex-class';
import {
  AuditDetail,
  AuditCriteria,
  UpdateAuditCriteriaRequestPayload,
} from '@/store/modules/audits/types/audits.types';
import {
  CplusCriteria,
  UpdateCriteriaDTO,
} from '@/store/modules/projects/types/projects.types';
import {
  isDifferentDeep,
  isTruthy,
} from '@/jbi-shared/util/watcher.vue-decorator';
import { isEqual as _isEqual } from 'lodash';
import { ToastProgrammatic as Toast } from 'buefy';
import JBICriteriaSelection from '@/views/Audit/components/JBICriteriaSelection.vue';
import {
  JBICriteriaDTO,
  ProjectCriteria,
} from '../../../store/modules/projects/types/projects.types';
import { transformCriteriaIntoCplusDTO } from '@/utils/criteria.util';

@Component({
  components: {
    JBICriteriaSelection,
    AuditCriteriaList,
  },
})
export default class AuditCriteriaTab extends Vue {
  @Prop({ default: true }) public editable!: boolean;
  @Prop() public auditId!: number;
  @Prop() public auditDetail!: AuditDetail;
  @Prop({ type: Boolean, default: false })
  public isAuditCycleCommencedOrCompleted!: boolean;

  public selectedCriteriaArray: CplusCriteria[] = [];
  public isAuditCriteriaSubmitButtonDisabled = true;
  public dirtyCriteriaArray: CplusCriteria[] = [];
  public deletedCriteriaList: number[] = [];

  @Action('projects/getProjectCriteria')
  public getProjectCriteria!: (projectId: number) => void;

  @State((state) => state.projects.projectCriteria)
  public projectCriteria!: ProjectCriteria[];

  @Action('audits/getAuditCriteria')
  public getAuditCriteria!: (auditId: number) => void;

  @State((state) => state.audits.auditCriteria)
  public auditCriteria!: AuditCriteria[];

  @State((state) => state.audits.apiState.getAuditCriteria.success)
  public getAuditCriteriaApiStateSuccess!: boolean;

  @Action('audits/updateAuditCriterias')
  public updateAuditCriterias!: (
    payload: UpdateAuditCriteriaRequestPayload,
  ) => void;

  @State((state) => state.audits.updatedAuditCriterias)
  public updatedAuditCriterias!: any;

  @State((state) => state.audits.updatedAuditJBICriteriaList)
  public updatedAuditJBICriteriaList!: JBICriteriaDTO[];

  @State(
    (state) => state.audits.apiState.getUpdatedAuditJBICriteriaList.success,
  )
  public getUpdatedAuditJBICriteriaListSuccess!: boolean;

  public mounted() {
    this.getAuditCriteria(this.auditId);
    this.getProjectCriteria(this.auditDetail.project.id);
  }

  get selectedCriteriaList() {
    return this.selectedCriteriaArray;
  }

  set selectedCriteriaList(newValue: CplusCriteria[]) {
    this.selectedCriteriaArray = newValue;
  }

  /** Get Project level criteria which are not added into audit-cycle */
  get filteredProjectCriteria(): CplusCriteria[] {
    const filteredCriteria = this.projectCriteria.filter((pc) => {
      const isCriteriaAddedToCycle = this.auditCriteria.find(
        (ac) => ac.criteria.id === pc.id,
      );
      return isCriteriaAddedToCycle ? false : true;
    });

    return transformCriteriaIntoCplusDTO(
      filteredCriteria,
      this.updatedAuditJBICriteriaList,
      true,
    );
  }

  get infoMessage() {
    if (this.auditDetail.endedAt !== null) {
      return `No changes are allowed as this data collection period has already ended.`;
    } else if (this.auditDetail.startedAt !== null) {
      return `No changes are allowed as this data collection period has already commenced.`;
    }
  }

  @Watch('getAuditCriteriaApiStateSuccess')
  @isTruthy
  public watchAuditCriteriaSuccess(): void {
    this.transformCriterias(this.auditCriteria);
  }

  @Watch('getUpdatedAuditJBICriteriaListSuccess')
  @isTruthy
  public watchUpdatedAuditJBICriteriaListSuccess(): void {
    if (this.getAuditCriteriaApiStateSuccess) {
      this.transformCriterias(this.auditCriteria);
    }
  }

  public transformCriterias(criterias: any[]) {
    this.dirtyCriteriaArray = [];
    this.selectedCriteriaArray = transformCriteriaIntoCplusDTO(
      criterias,
      this.updatedAuditJBICriteriaList,
      false,
    );
  }

  @Watch('selectedCriteriaArray')
  @isTruthy
  @isDifferentDeep
  public watchSelectedCriteriaArray(newValue: any) {
    this.isAuditCriteriaSubmitButtonDisabled = _isEqual(
      this.dirtyCriteriaArray,
      newValue,
    );
  }

  @Watch('updatedAuditCriterias')
  @isTruthy
  public watchUpdatedAuditCriterias() {
    this.getAuditCriteria(this.auditId);
    Toast.open({
      message: `Criteria successfully updated.`,
      position: 'is-top',
      type: 'is-dark',
      duration: 3500,
    });
  }

  public openJBICriteriaSelectionTemplate() {
    this.$buefy.modal.open({
      parent: this,
      component: JBICriteriaSelection,
      fullScreen: true,
      hasModalCard: false,
      trapFocus: true,
      animation: 'unset',
      props: {
        auditName: this.auditDetail.name,
        selectedCriteriaArray: this.selectedCriteriaArray,
        filteredProjectCriteria: this.filteredProjectCriteria,
        isProjectLevel: false,
      },
      events: {
        updateSelectedCriteriaArray: (newValue: UpdateCriteriaDTO) => {
          this.selectedCriteriaArray = newValue.emitCriteriaArray;
          this.deletedCriteriaList = newValue.deletedCriteriaIds;
          this.updateAuditCriteriaHandler();
        },
      },
    });
  }

  public handleDeletedCriteria(criteria: any) {
    if (criteria.criteriaDetails) {
      this.deletedCriteriaList.push(criteria.criteriaDetails.id);
    }
  }

  public updateAuditCriteriaHandler() {
    this.updateAuditCriterias({
      auditId: this.auditId,
      criteriaList: this.selectedCriteriaArray,
      deletedCriteriaIds: this.deletedCriteriaList,
    });
  }

  public handleRestoreFromOverlay(): void {
    // Using Vue & interface instead of 'any' for type-safe access to component properties
    const auditCriteriaList = this.$refs.auditCriteria as Vue & {
      isMinimized: boolean;
    };
    if (auditCriteriaList) {
      auditCriteriaList.isMinimized = false;
    }
  }
}
